(() => {
  if (window.pgrsRoomSetEventsAdded) return;
  window.pgrsRoomSetEventsAdded = true;
  document.documentElement.classList.add('pgrs-custom-select-ready');

  function initRoomSet(gallery) {
    const card = gallery.querySelector('[data-pgrs-room-set]');
    if (!card || card.dataset.pgrsInitialized === 'true') return;
    card.dataset.pgrsInitialized = 'true';
    let frame = 0;

    function position() {
      frame = 0;
      if (!gallery.isConnected || !card.isConnected) return;
      const collage = gallery.querySelector('.product-media-collage');
      const desktop = collage && getComputedStyle(collage).display !== 'none';
      const container = desktop ? collage : gallery.querySelector('.main-image carousel-slider');
      if (!container) {
        card.hidden = true;
        return;
      }
      const selector = desktop ? '.product-media-collage__item' : '.slider__item';
      const visibleItems = [...container.querySelectorAll(selector)].filter((item) =>
        !item.hidden && getComputedStyle(item).display !== 'none' && item.getClientRects().length > 0
      );
      const preferredIndex = Math.max(0, Number(card.dataset.pgrsTargetPosition || 2) - 1);
      const target = visibleItems.find((item) => item.dataset.mediaId === card.dataset.pgrsTargetMediaId)
        || visibleItems[preferredIndex];
      if (!target) {
        card.hidden = true;
        return;
      }
      const image = target.querySelector('.product-media') || target.querySelector('.img-ar') || target;
      const imageRect = image.getBoundingClientRect();
      const galleryRect = gallery.getBoundingClientRect();
      if (imageRect.width < 40 || imageRect.height < 40) {
        card.hidden = true;
        return;
      }
      if (!desktop) {
        const viewport = container.getBoundingClientRect();
        const visibleWidth = Math.min(imageRect.right, viewport.right) - Math.max(imageRect.left, viewport.left);
        if (visibleWidth < imageRect.width * 0.5) {
          card.hidden = true;
          return;
        }
      }
      card.style.visibility = 'hidden';
      card.hidden = false;
      card.style.maxWidth = `${Math.max(120, imageRect.width - 16)}px`;
      const inset = window.innerWidth <= 767 ? 10 : 14;
      const cardRect = card.getBoundingClientRect();
      card.style.left = `${imageRect.left - galleryRect.left + inset}px`;
      card.style.top = `${Math.max(imageRect.top - galleryRect.top + inset, imageRect.bottom - galleryRect.top - cardRect.height - inset)}px`;
      card.style.visibility = '';
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(position);
    }

    const observer = new MutationObserver(schedule);
    observer.observe(gallery, { childList: true, subtree: true });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(gallery);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    gallery.addEventListener('on:carousel-slider:select', schedule);
    gallery.addEventListener('on:variant:change', schedule);
    document.addEventListener('on:media-gallery:change', schedule);
    window.addEventListener('load', schedule, { once: true });
    schedule();
  }

  function initRoomSets(scope = document) {
    scope.querySelectorAll('media-gallery').forEach(initRoomSet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRoomSets(), { once: true });
  } else {
    initRoomSets();
  }
  document.addEventListener('shopify:section:load', (event) => initRoomSets(event.target));

  function updateSelection(modal) {
    const button = modal.querySelector('[data-pgrs-add]');
    if (!button || button.dataset.loading === 'true') return;
    const selected = [...modal.querySelectorAll('[data-pgrs-item]')].filter((item) => {
      const checkbox = item.querySelector('[data-pgrs-select]');
      const variant = item.querySelector('[data-pgrs-variant-id]');
      return checkbox?.checked && !checkbox.disabled && variant?.value;
    });
    button.disabled = selected.length === 0;
    button.textContent = selected.length ? `Add ${selected.length} item${selected.length === 1 ? '' : 's'} to cart` : 'Select a product';
  }

  function updateVariant(select) {
    const item = select.closest('[data-pgrs-item]');
    const modal = select.closest('[data-pgrs-modal]');
    if (!item || !modal) return;
    const dataNode = item.querySelector('[data-pgrs-variants]');
    const variantInput = item.querySelector('[data-pgrs-variant-id]');
    const checkbox = item.querySelector('[data-pgrs-select]');
    if (!dataNode || !variantInput || !checkbox) return;
    let variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch {
      return;
    }
    const options = [...item.querySelectorAll('[data-pgrs-option-select]')].map((input) => input.value);
    const variant = variants.find((candidate) =>
      candidate.options.length === options.length &&
      candidate.options.every((value, index) => value === options[index])
    );
    variantInput.value = variant?.available ? variant.id : '';
    checkbox.disabled = !variant?.available;
    if (checkbox.disabled) checkbox.checked = false;
    const price = item.querySelector('[data-pgrs-price-current]');
    const compare = item.querySelector('[data-pgrs-price-compare]');
    if (variant && price) price.textContent = variant.price;
    if (compare) {
      compare.textContent = variant?.compareAtPrice || '';
      compare.hidden = !variant?.compareAtPrice;
    }
    updateSelection(modal);
  }

  function syncMobileOption(select) {
    const option = select.closest('.pgrs__modal-option');
    const summary = option?.querySelector('[data-pgrs-mobile-summary]');
    const label = summary?.querySelector('[data-pgrs-mobile-option-label]');
    const selectedText = select.selectedOptions[0]?.textContent?.trim() || select.value;
    if (label) label.textContent = selectedText;
    if (summary) summary.setAttribute('aria-label', `${select.getAttribute('aria-label')}: ${selectedText}`);
    option?.querySelectorAll('[data-pgrs-mobile-choice]').forEach((choice) => {
      choice.setAttribute('aria-pressed', String(choice.dataset.value === select.value));
    });
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-pgrs-option-select]')) {
      syncMobileOption(event.target);
      updateVariant(event.target);
    } else if (event.target.matches('[data-pgrs-select]')) {
      const modal = event.target.closest('[data-pgrs-modal]');
      if (modal) updateSelection(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const picker = event.target.closest('.pgrs__mobile-option-picker[open]');
    if (!picker) return;
    event.preventDefault();
    event.stopPropagation();
    picker.open = false;
    picker.querySelector('[data-pgrs-mobile-summary]')?.focus();
  });

  document.addEventListener('click', async (event) => {
    const summary = event.target.closest('[data-pgrs-mobile-summary]');
    if (summary) {
      const picker = summary.closest('.pgrs__mobile-option-picker');
      const modal = summary.closest('[data-pgrs-modal]');
      modal?.querySelectorAll('.pgrs__mobile-option-picker[open]').forEach((other) => {
        if (other !== picker) other.open = false;
      });
      return;
    }
    const choice = event.target.closest('[data-pgrs-mobile-choice]');
    if (choice) {
      const option = choice.closest('.pgrs__modal-option');
      const select = option?.querySelector('[data-pgrs-option-select]');
      const picker = choice.closest('.pgrs__mobile-option-picker');
      if (!select || !picker) return;
      select.value = choice.dataset.value;
      picker.open = false;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      picker.querySelector('[data-pgrs-mobile-summary]')?.focus();
      return;
    }
    const button = event.target.closest('[data-pgrs-add]');
    if (!button) return;
    const modal = button.closest('[data-pgrs-modal]');
    if (!modal || button.disabled || button.dataset.loading === 'true') return;
    const status = modal.querySelector('[data-pgrs-status]');
    const merged = new Map();
    for (const item of modal.querySelectorAll('[data-pgrs-item]')) {
      const checkbox = item.querySelector('[data-pgrs-select]');
      const variantInput = item.querySelector('[data-pgrs-variant-id]');
      if (!checkbox?.checked || checkbox.disabled || !variantInput?.value) continue;
      const id = Number(variantInput.value);
      if (!Number.isSafeInteger(id) || id <= 0) continue;
      merged.set(id, (merged.get(id) || 0) + 1);
    }
    if (merged.size === 0) {
      updateSelection(modal);
      return;
    }
    const items = [...merged].map(([id, quantity]) => ({ id, quantity }));
    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root.endsWith('/') ? root : `${root}/`}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart add failed');
      await response.json();
      modal.close();
      const opener = document.querySelector(`[aria-controls="${modal.id}"]`) || button;
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener } }));
      modal.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: items[0].id } }));
      const drawer = document.querySelector('.js-cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(opener);
    } catch {
      if (status) status.textContent = 'Could not add the selected products. Please try again.';
    } finally {
      button.dataset.loading = 'false';
      updateSelection(modal);
    }
  });
})();
